//@flow
export const CONFIRMATION_MESSAGE = `All traces of this slide will be gone.`



// WEBPACK FOOTER //
// ./src/Slides/constants.js